import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, ExternalLink, ArrowUpRight } from 'lucide-react';

const Footer: React.FC<{ className?: string }> = ({ className = '' }) => {
  const links = [
    { label: '센터 소개', to: '/about' },
    { label: '연구 분과', to: '/divisions' },
    { label: '운영세칙', to: '/governance' },
    { label: '교육 헌장', to: '/charter' },
    { label: '참여 교수진', to: '/faculty' },
    { label: '인간-AI 컬럼', to: '/column' },
    { label: '행사 (AI4HER)', to: '/ai4her' },
    { label: '새소식', to: '/news' },
  ];

  return (
    <footer className={`bg-navy-950 text-white ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10 md:gap-8">
          {/* 센터 정보 */}
          <div className="md:col-span-5">
            <div className="flex items-center mb-5">
              <img
                src="/chair-logo.png"
                alt="CHAIR"
                className="h-10 w-auto mr-3 brightness-0 invert opacity-90"
              />
              <div>
                <div className="font-bold text-lg leading-tight tracking-tight">CHAIR</div>
                <div className="text-xs text-navy-300 mt-0.5 tracking-wide">
                  Center for Human-AI Research
                </div>
              </div>
            </div>
            <p className="text-navy-300 text-sm leading-relaxed max-w-sm">
              인간의 창의성과 AI의 계산 능력을 결합하여
              협력적 미래를 만들어가는 서울여자대학교 연구센터입니다.
            </p>
            <a
              href="https://www.swu.ac.kr"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center mt-5 text-sm text-teal-400 hover:text-teal-300 transition-colors group"
            >
              서울여자대학교
              <ArrowUpRight className="h-3.5 w-3.5 ml-1 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          </div>

          {/* 연락처 */}
          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-navy-400 mb-5">
              Contact
            </h4>
            <ul className="space-y-3.5 text-sm text-navy-300">
              <li className="flex items-start">
                <MapPin className="h-4 w-4 mr-2.5 mt-0.5 flex-shrink-0 text-teal-500" />
                <span className="leading-relaxed">
                  서울특별시 노원구 화랑로 621
                  <br />서울여자대학교
                </span>
              </li>
              <li className="flex items-center">
                <Mail className="h-4 w-4 mr-2.5 flex-shrink-0 text-teal-500" />
                <a
                  href="mailto:chair@swu.ac.kr"
                  className="hover:text-white transition-colors"
                >
                  chair@swu.ac.kr
                </a>
              </li>
            </ul>
          </div>

          {/* 사이트맵 */}
          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold uppercase tracking-widest text-navy-400 mb-5">
              Sitemap
            </h4>
            <div className="grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm">
              {links.map(({ label, to }) => (
                <Link
                  key={to}
                  to={to}
                  className="text-navy-300 hover:text-teal-400 transition-colors duration-200"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* 하단 */}
        <div className="border-t border-navy-800/60 mt-12 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-navy-500">
            &copy; {new Date().getFullYear()} Center for Human-AI Research (CHAIR), Seoul Women's University
          </p>
          <p className="text-xs text-navy-600">
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
